import React from 'react';
import { motion } from 'framer-motion';
import { MapPin, Wrench, Users } from 'lucide-react';
import Header from '../components/Header';
import bgtrace from '../assets/bgtrace1.jpeg';

const About = () => {
  return (
    <div className="min-h-screen bg-white">
      <Header />
      
      <main className="pt-20">
        {/* Hero Section */}
        <section 
          className="py-20 bg-gradient-to-b from-gray-50 to-white"
          style={{
            backgroundImage: `url(${bgtrace})`,
            backgroundSize: 'cover',
            backgroundPosition: 'center',
            backgroundRepeat: 'no-repeat',
            backgroundAttachment: 'fixed'
          }}
        >
          <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
            <motion.div
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6 }}
            >
              <h1 className="text-4xl md:text-5xl font-display font-bold text-black mb-6 drop-shadow">
                About <span className="text-brandred">The Taco Garage</span>
              </h1>
              <p className="text-xl text-gray-600 max-w-3xl mx-auto leading-relaxed">
                The Taco Garage is your trusted shop for Tacoma upgrades in Chula Vista, CA. 
                We install what we sell and carry only high-quality parts. Whether you're ordering 
                online or stopping by the shop, our team of Toyota truck specialists is here to help.
              </p>
            </motion.div>
          </div>
        </section>

        {/* Content Sections */}
        <section 
          className="py-20"
          style={{
            backgroundImage: `url(${bgtrace})`,
            backgroundSize: 'cover',
            backgroundPosition: 'center',
            backgroundRepeat: 'no-repeat',
            backgroundAttachment: 'fixed'
          }}
        >
          <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
            <div className="grid grid-cols-1 lg:grid-cols-3 gap-12">
              
              {/* Our Mission */}
              <motion.div
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.6 }}
                className="text-center bg-[#F3F3F3] rounded-xl p-8 shadow-lg border border-gray-300/30"
              >
                <div className="w-16 h-16 bg-brandred/10 rounded-full flex items-center justify-center mx-auto mb-6">
                  <Wrench className="text-brandred" size={32} />
                </div>
                <h3 className="text-2xl font-bold text-black mb-4">Our Mission</h3>
                <p className="text-gray-700">
                  To provide Tacoma owners with the highest quality parts and professional 
                  installation services, backed by our expertise and commitment to customer satisfaction.
                </p>
              </motion.div>

              {/* Our Location */}
              <motion.div
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.6, delay: 0.2 }}
                className="text-center bg-[#F3F3F3] rounded-xl p-8 shadow-lg border border-gray-300/30"
              >
                <div className="w-16 h-16 bg-brandred/10 rounded-full flex items-center justify-center mx-auto mb-6">
                  <MapPin className="text-brandred" size={32} />
                </div>
                <h3 className="text-2xl font-bold text-black mb-4">Our Location</h3>
                <p className="text-gray-700">
                  Located in Chula Vista, CA, our shop is easily accessible to Tacoma 
                  owners throughout San Diego County and beyond.
                </p>
              </motion.div>

              {/* Our Team */}
              <motion.div
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.6, delay: 0.4 }}
                className="text-center bg-[#F3F3F3] rounded-xl p-8 shadow-lg border border-gray-300/30"
              >
                <div className="w-16 h-16 bg-brandred/10 rounded-full flex items-center justify-center mx-auto mb-6">
                  <Users className="text-brandred" size={32} />
                </div>
                <h3 className="text-2xl font-bold text-black mb-4">Our Team</h3>
                <p className="text-gray-700">
                  Our certified technicians specialize in Toyota trucks and ensure every 
                  installation meets factory standards and your expectations.
                </p>
              </motion.div>
            </div>
          </div>
        </section>

        {/* Contact Info */}
        <section 
          className="py-20"
          style={{
            backgroundImage: `url(${bgtrace})`,
            backgroundSize: 'cover',
            backgroundPosition: 'center',
            backgroundRepeat: 'no-repeat',
            backgroundAttachment: 'fixed'
          }}
        >
          <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
            <motion.div
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.6 }}
            >
              <h2 className="text-3xl md:text-4xl font-display font-bold text-black mb-8">
                Visit Our <span className="text-brandred">Shop</span>
              </h2>
              <div className="bg-[#F3F3F3] rounded-xl p-8 shadow-lg border border-gray-300/30">
                <div className="space-y-4 text-gray-700">
                  <p className="text-xl font-semibold text-black">Taco Garage</p>
                  <p>1409 Broadway, Suite 101</p>
                  <p>Chula Vista, CA 91911</p>
                  <p className="text-brandred font-medium">Tuesday - Saturday 10am to 5pm</p>
                </div>
              </div>
            </motion.div>
          </div>
        </section>
      </main>

      {/* <Footer /> */}
    </div>
  );
};

export default About; 